export default __webpack_public_path__ + "static/media/1111.f30fb259.png";